import { Component, Input } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

export interface VolumetryTableRow {
  name: string;
  totalMaintenancesDone: number;
  totalMaintenancesCanceled: number;
  totalMaintenancesBacklog: number;
  totalMaintenances: number;
  maintenances: Array<{
    name: string
    series: Array<{
      name: string
      value: number
    }>
  }>;
}

@Component({
  selector: 'data-volumetry-table',
  templateUrl: './data-volumetry-table.component.html',
  styleUrls: ['./data-volumetry-table.component.scss'],
})
export class DataVolumetryTableComponent {
  @Input() title: string;
  @Input() dataSource: VolumetryTableRow[] = [];
  @Input() isLoading = true;

  displayedColumns = [
    'name',
    'totalMaintenancesDone',
    'totalMaintenancesCanceled',
    'totalMaintenancesBacklog',
    'totalMaintenances',
    'maintenancesByDay'
  ];

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }
}
